<template>
    <div class="container mt-4">
        <gamification-hole-progress
            :color="color"
            :student="student"
            :plan="plan"
            :gamification-rules="gamificationRules"
            :plan-name="planName"
        />
    </div>
</template>

<script>
import GamificationHoleProgress from './GamificationHoleProgress.vue';

export default {
    name: 'GamificationShowHoleProgress',

    components: {
        GamificationHoleProgress,
    },

    props: {
        gamificationRules: Object,
        userRoles: Object,
        breadcrumbItems: Array,
        rules: {
            type: Array,
            default: () => ([])
        },
        color: {
            type: Object,
            required: true,
        },
        student: {
            type: Object,
            required: true,
        },
        plan: Object,
        planName: String,
    },

    data() {
        return {
            
        };
    },

    computed: {
        language() {
            return this.$store.getters.LANGUAGE;
        },
    },

    methods: {
        
    },

    mounted() {
        
    }
};
</script>

<style scope>
.form-group {
  margin-bottom: 10px;
}

.input-container {
  max-width: 400px;
  width: 100%;
  margin-right: 20px;
}

.nch--custom-switch {
    margin-bottom: 20px;
}
</style>
